// extracted by mini-css-extract-plugin
export default {"infos":"Infos_infos__fnOmI"};